/*
* 通用引入，包含element-ui等
* */
// standalone   vue/dist/vue.js
// runtime      vue/dist/vue.common.js
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 2.0
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// 项目公用样式
import '@/assets/css/_variable.scss';
import '@/assets/css/_mixin.scss';
import '@/assets/css/style.scss';
// import 全局filter
import '@/utils/filter.js';
// import 全局方法
import '@/utils/method.js';

// import 全局指令
import '@/utils/directives.js';
// 混入
import '@/utils/mixins.js';

import store from '@/store/store.js';

// use element-ui
Vue.use(ElementUI); 


// 主题写入store
// const curTheme = localStorage.getItem('theme');
// if (curTheme) {
//   window.document.documentElement.setAttribute("data-theme", curTheme);
//   window.localStorage.setItem("theme", curTheme);
//   store.commit("TOGGLE_THEME", {theme: curTheme});
// } else {
//   window.document.documentElement.setAttribute("data-theme", "day");
// }
window.document.documentElement.setAttribute("data-theme", "day");


const loginInfo = sessionStorage.getItem('developer_user_info');

if (loginInfo) {
  store.commit('setLoginUser', {
    loginUser: JSON.parse(loginInfo)
  });
  store.commit('setLoginToken', {
    loginToken: true
  });
} else {
  store.commit('setLoginToken', {
    loginToken: false
  });
}
